import { publishEvent } from './publishers';
import { currentUserContract, type CurrentUserData } from 'shared/domain/currentUser/currentUserContract';
import { DomainMessagesTypes } from 'shared/domain/messages/message';
import { debugLog } from 'shared/logger/debugLog';

/** The logged-in user with the permissions the worker downloaded, for the page. */
export function broadcastCurrentUserPermissions(data: CurrentUserData, source: string): void {
  debugLog('broadcastCurrentUserPermissions', source);
  publishEvent(currentUserContract, DomainMessagesTypes.currentUserPermissions, data);
}
